import { updateLessonImage } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { convertFileToBase64 } from "helpers/fileHelper";

export const useUpdateLessonImage = () => {
    const { callAPI } = useWorkspaceApiCall(updateLessonImage, '', 'updateLessonImage.error');

    const updateLessonImageFromFile = async (lessonId: string, imageFile: File): Promise<boolean> => {
        try {
            const base64String = await convertFileToBase64(imageFile);
            const base64WithoutPrefix = (base64String as string).split(',')[1];
            const extension = imageFile.name.split('.').pop() ?? null;

            if (!base64WithoutPrefix || !extension) return false;

            const response = await callAPI({
                lessonId: lessonId,
                base64Photo: base64WithoutPrefix,
                photoExtension: extension
            });

            return response?.success || false;
        } catch (error) {
            console.error('Error occurred while updating the lesson image:', error);
            return false;
        }
    };

    return { updateLessonImage: callAPI, updateLessonImageFromFile };
};